import React from 'react'

export default function ArrowRightClick() {
  return (
    <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2L7 6.58333L2 11.1667" stroke="#3249D7" strokeWidth="3" strokeLinecap="round"/>
    </svg>
    
    
  )
}
